import { useState } from 'react';

import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

import {
  QS_ADID,
  QS_AD_CREATIVE,
  QS_AD_GROUP,
  QS_GCLID,
  QS_UTM_CONTENT,
  QS_UTM_TERM,
  UtmCampaign,
  UtmMedium,
  UtmSource,
} from '../constants';

import { useBranch } from './useBranch';

export const useBranchCreateLink = () => {
  const branch = useBranch();
  const [branchLink, setBranchLink] = useState<string | null>(null);

  const {
    location: {
      search,
    },
  } = useHistory();

  const searchParams = queryString.parse(search);
  const {
    utm_source: utmSource,
    utm_medium: utmMedium,
    utm_campaign: utmCampaign,
    [QS_UTM_TERM]: utmTerm,
    [QS_UTM_CONTENT]: utmContent,
    [QS_GCLID]: gclid,
    [QS_AD_GROUP]: adGroup,
    [QS_AD_CREATIVE]: adCreative,
    [QS_ADID]: adid,
    ...restSearchParams
  } = searchParams;

  // Channel, feature, and campaign could potentially be arrays in the URL if for -any- reason
  // the params are specified multiple times in the URL (ex: utm_campaign=utm1&utm_campaign=utm2).
  // Therefore, we will just pick the first element in the array in this particular edge case. If
  // the value is a regular string (as typically expected), then we just use the string.
  // Otherwise, we use the default values for specific utms
  const branchData = {
    channel:
      (Array.isArray(utmSource) ? utmSource[0] : utmSource) || UtmSource.Web,
    feature:
      (Array.isArray(utmMedium) ? utmMedium[0] : utmMedium)
      || UtmMedium.Organic,
    campaign:
      (Array.isArray(utmCampaign) ? utmCampaign[0] : utmCampaign)
      || UtmCampaign.WebFunnel,
    data: {
      [QS_AD_CREATIVE]: (Array.isArray(adCreative) ? adCreative[0] : adCreative),
      [QS_UTM_TERM]: (Array.isArray(utmTerm) ? utmTerm[0] : utmTerm),
      [QS_UTM_CONTENT]: (Array.isArray(utmContent) ? utmContent[0] : utmContent),
      [QS_GCLID]: (Array.isArray(gclid) ? gclid[0] : gclid),
      [QS_AD_GROUP]: (Array.isArray(adGroup) ? adGroup[0] : adGroup),
      [QS_ADID]: (Array.isArray(adid) ? adid[0] : adid),
      ...restSearchParams,
    },
  };

  if (branch) {
    branch.link(branchData, (err, link) => {
      if (err) {
        const { Rollbar } = window;
        Rollbar.error(`Branch link error: ${err}`);
        return;
      }

      setBranchLink(link);
    });
  }

  return branchLink;
};
